import { useEffect, useMemo, useState } from "react";
import Table from "../../components/GTable/Table";
import { GetCategoriesData, GetProductByIdData, GetProductsData } from "../../lib/data";
import Button from "../../components/GButton/Button";
import { productsColumns, statusOfProducts } from "../../lib/definitions";
import { deleteProductsForm } from "../../lib/actions";
import DeleteRecord from "../../ui/Models/deleteRecord";
import Pagination from "../../ui/paginations/Paginations";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import { useSearchParams } from "react-router-dom";
import ProductsFilter from "../../ui/searchFilter/productsFilter";
import i18n from "../../lib/i18n";
import ProductDetailsPopUp from "../../ui/sharedUi/productDetailsPopUp";

    export default function Products() {

        const [searchParams] = useSearchParams();
        const [productsData, setProductsData] = useState([]);
        const [productsByIdData, setProductsByIdData] = useState({});
        const [categoriesData, setCategoriesData] = useState([]);
        const [subCategoriesData, setSubCategoriesData] = useState([]);
        const [openDetails, setOpenDetails] = useState({ isOpen: false, idToOpen: null });
        const [currentPage, setcurrentPage] = useState(1);
        const [last_page, setlast_page] = useState(1);
        const [deleteConfirmation, setDeleteConfirmation] = useState({ isOpen: false, idToDelete: null });
        const [isLoading, setIsLoading] = useState(true);
        const [loadingDelete, setLoadingDelete] = useState(false);
        const category_id = searchParams.get('category_id');
        const name = searchParams.get('name');
        const price = searchParams.get('price');
        const sub_category_id = searchParams.get('sub_category_id');
        const accept = searchParams.get('accept');
        const t = i18n.t.bind(i18n);

        const params = useMemo(() => {
            const tempParams = [];
            if (category_id) tempParams.push({ category_id });
            if (name) tempParams.push({ name });
            if (accept) tempParams.push({ accept });
            if (sub_category_id) tempParams.push({ sub_category_id });
            if (price) tempParams.push({ price });
            return tempParams;
        }, [ price, category_id, name, sub_category_id, accept]);

        useEffect(() => {
            handleApi();
        }, [currentPage, params]);

        useEffect(() => {
            handleFilter();
        }, []);

        useEffect(() => {
            handleGetProductById();
        }, [openDetails.idToOpen]);

        const handleApi = async () => {
            setIsLoading(true);
            const res = await GetProductsData(currentPage, params);
            setProductsData([]);
            setcurrentPage(res.pagination.current_page);
            setlast_page(res.pagination.last_page );
            res.data?.map((e) => setProductsData((prev) => [...prev, e]));
            setIsLoading(false);
        };

        const handleFilter = async () => {
            const categoriesParams = [{"status": "main"}];
            const subCategoriesParams = [{"status": "sub"}];
            const categoriesDataFilter = await GetCategoriesData(1, categoriesParams);
            const subCategoriesDataFilter = await GetCategoriesData(1, subCategoriesParams);
            setCategoriesData([]);
            setSubCategoriesData([]);
            categoriesDataFilter.data.map((e) => setCategoriesData((prev) => [...prev, e]));
            subCategoriesDataFilter.data.map((e) => setSubCategoriesData((prev) => [...prev, e]));
        };

        const searchCategories = async (param) => {
            const params = [{ name: param }, {"status": "main"}];
            if (param) {
                const res = await GetCategoriesData(1, params);
                setCategoriesData([]);
                res.data?.map((e) => setCategoriesData((prev) => [...prev, e]));
            }
        };

        const searchSubCategories = async (param) => {
            const params = [{ name: param }, {"status": "sub"}];
            if (param) {
                const res = await GetCategoriesData(1, params);
                setSubCategoriesData([]);
                res.data?.map((e) => setSubCategoriesData((prev) => [...prev, e]));
            }
        };

        const handleGetProductById = async () => {
            if(openDetails.idToOpen){
                const getProductsById = await GetProductByIdData(openDetails.idToOpen);
                setProductsByIdData({});
                setProductsByIdData(getProductsById.data);
            };
        };

        const openOrderDetails = (id) => {
            setOpenDetails({ isOpen: true, idToOpen: id });
        };

        const handlePageChange = (page) => {
            setcurrentPage(page);
        };

        const openDeleteConfirmation = (id) => {
            setDeleteConfirmation({ isOpen: true, idToDelete: id });
        };

        const closeDeleteConfirmation = () => {
            setDeleteConfirmation({ isOpen: false, idToDelete: null });
        };

        const handelDelete = async () => {
            if (deleteConfirmation.idToDelete) {
                setLoadingDelete(true);
                const result = await deleteProductsForm(deleteConfirmation.idToDelete);
                if (result) {
                    setLoadingDelete(false);
                    handleApi();
                }
                closeDeleteConfirmation();
            }
        };

        return (
            <div className="p-8 sm:p-6 md:p-8">
                <div className="">
                    <ProductsFilter searchCategories={searchCategories} searchSubCategories={searchSubCategories} categoriesData={categoriesData} subCategoriesData={subCategoriesData} statusOfProducts={statusOfProducts} values={params} />
                </div>
                <div className="flex flex-col sm:flex-row sm:items-baseline border-t border-gray-500/100 bg-thirdly justify-between px-5 py-5 gap-4">
                    <div></div>
                    <Button background="#2F7A74" borderRadius="8px" color="white" padding="8px 20px" text={t("button.add_products")} nav={'/products/add'} />
                </div>
                <div>
                    {isLoading ? <TableSkeleton cols={productsColumns}/> : (
                    <Table columns={productsColumns} rows={productsData} openDeleteConfirmation={openDeleteConfirmation} openOrderDetails={openOrderDetails} action={"accept"} edit="/products/edit" />
                    )}
                </div>
                <div className="flex justify-center items-center py-5">
                    <Pagination currentPage={currentPage} totalPages={last_page} handleChangePage={handlePageChange} />
                </div>
                    {deleteConfirmation.isOpen && <DeleteRecord loadingDelete={loadingDelete} handelDelete={handelDelete} closeDeleteConfirmation={closeDeleteConfirmation} />}
                    {openDetails.isOpen && openDetails.idToOpen && <ProductDetailsPopUp data={productsByIdData} onClose={() => setOpenDetails({ isOpen: false, idToOpen: null })}/>}
                </div>
        );
    };